import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { IUITKColumnState, IUITKSelectItemProps, UITKSortDirection, UITKTableDataSource, UITKTableSortDirective,
  IUITKPaginationConfig, UITKHeadingLevel, IUITKPaginationEntriesPerPage, PAGINATION_EVENTS, IUITKPaginationEvent,
  UITKDatePickerComponent} from '@uitk/angular';
import { Subscription } from 'rxjs';
import { AccountBalanceDto } from '../../../dtos/account-balance-dto-model';
import { BillToDto } from 'src/app/dtos/bill-to-dto.model';
import { ConfigService } from 'src/app/services/config.service';
import { ModeService } from 'src/app/services/mode.service';
import { AccountResultDto } from '../../../dtos/account-result-dto.model';
import { AccountsReceivableResultsDto } from '../../../dtos/accounts-receivable-results-dto.model';
import { InvoiceDetailsDto } from '../../../dtos/invoice-details-dto.model';
import { OpenReceivableDto } from '../../../dtos/open-receivable-dto.model';
import { PaymentDetailDto } from '../../../dtos/payment-detail-dto.model';
import { AccountsReceivableService } from '../../../services/accounts-receivable.service';
import { InvoicesService } from '../../../services/invoices.service';
import { InvoiceEditComponent } from '../invoice-edit/invoice-edit.component';
import { Dialog } from 'src/app/helpers/dialog';
import { OrderService } from 'src/app/services/order.service';
import { SwalAlert } from '../../../helpers/alert';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { SearchInvoiceByCCService } from 'src/app/services/search-invoice-bycc.service';

@Component({
  selector: 'app-accounts-receivable-results',
  templateUrl: './accounts-receivable-results.component.html',
  styleUrls: ['./accounts-receivable-results.component.css']
})
export class AccountsReceivableResultsComponent implements OnInit, OnDestroy {
  @ViewChild('sortTable') uitkTableSort!: UITKTableSortDirective;
  @ViewChild(InvoiceEditComponent) invoiceEditComponent: InvoiceEditComponent | undefined;
  @ViewChild('sortPaymentTable') uitkPaymentTableSort!: UITKTableSortDirective;
  @ViewChild('datePic') datePic!: UITKDatePickerComponent;
  @Input() invoiceNumber = '';
  @Input() orderNumber = '';
  @Output() invoiceEdited = new EventEmitter<null>();

  currentPageSize: number = 500;
  paginationConfig: IUITKPaginationConfig = {
    id: 'pagination-id',
    description: 'Pagination',
    currentPageNumber: 1,
    displayingPagesTextHeadingLevel: UITKHeadingLevel.h2,
    nextButtonLabel: '>>',
    previousButtonLabel: '<<',
  };

  entriesPerPage: IUITKPaginationEntriesPerPage = {
    pageSizeOptions: [{ value: 500, selected: true }],
  };

  totalRecords = 1;
  requiredDatePickerForm = new UntypedFormGroup({
    fromDatePicker: new UntypedFormControl(''),
    toDatePicker: new UntypedFormControl(''),
  });
  isCustom = false;
  currentYear = new Date().getFullYear();
  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    public readonly accountsReceivableService: AccountsReceivableService,
    public readonly invoiceService: InvoicesService,
    public readonly orderService: OrderService,
    public readonly configService: ConfigService,
    private readonly _titleService: Title,
    public readonly _modeService: ModeService,
    private readonly apiService: ApiService, 
    private readonly searchInvoiceByCCService: SearchInvoiceByCCService
  ) {
  }

  defaultLabel = 'Please Select';
  defaultLabelFlag = false;
  getAccountsReceivableResultsSubscription: Subscription | undefined;
  getSelectedInvoicesSubscription: Subscription | undefined;
  accountInfo: AccountResultDto = new AccountResultDto();
  accountFields: BillToDto[] = [];
  accountFieldsSingle: BillToDto = new BillToDto();
  accountBalanceDto: AccountBalanceDto = new AccountBalanceDto();
  accountManager: any;
  accountManagerEmail:string | undefined;
  accountOwnerManagerCode:string|undefined;
  accountOwnerManager:string | undefined;
  accountOwnerManagerEmail:string | undefined;
  softwareExecutive: string|undefined;
  softwareExecutiveEmail:string | undefined;
  dataRep: string|undefined;
  dataRepEmail:string | undefined;
  printRep: string|undefined;
  printRepEmail:string | undefined;
  printManagerCode:string|undefined;
  printManager:string | undefined;
  printManagerEmail:string | undefined;
  dataSource = new UITKTableDataSource<InvoiceDetailsDto>([]);
  data: InvoiceDetailsDto[] = [];
  openReceivablesDataSource = new UITKTableDataSource<OpenReceivableDto>([]);
  filteredOpenReceivablesDataSource = new UITKTableDataSource<OpenReceivableDto>([]);
  getPaymentsSubscription: Subscription | undefined;
  paymentDetailsDataSource = new UITKTableDataSource<PaymentDetailDto>([]);
  filteredPaymentDetailsDataSource = new UITKTableDataSource<PaymentDetailDto>([]);
  isDataFound : any;
  selectedInvoices: InvoiceDetailsDto[] = [];
  openSendInvoicePDFPopup: boolean = false;
  sendInvoicePdfDialog = { show: false };
  showSelectedTemplate=new Dialog<string>();
  showTemplateEmail=new Dialog<void>();
  sendCCPdfAccess = false;
  tabLabel='Account Receivable';
  creditDescription = '';
  openReceivablesGridFilters: { fieldName: string, filterValue: string, filterApplied: boolean, columnName: string }[] = [];
  paymentGridFilters: { fieldName: string, filterValue: string, filterApplied: boolean, columnName: string }[] = [];
  invoicesGridFilters: { fieldName: string, filterValue: string }[] = [];
  yearsList: IUITKSelectItemProps[] = [
    { id: '1', label: '1 Year', value: '1' },
    { id: '2', label: '2 Years', value: '2' },
    { id: '3', label: '3 Years', value: '3' },
    { id: '4', label: '4 Years', value: '4' },
    { id: '5', label: '5 Years', value: '5' }
  ];
  invoiceYearFilter = { id: '3', label: '3 Year', value: '3' }; // Default value


  openReceivablesHeader = [
    { name: 'Invoice #', id: 'invoiceNumber' },
    { name: 'Invoice Date', id: 'invoiceDate' },
    { name: 'Ref #', id: 'referenceNumber' },
    { name: 'Order #', id: 'orderNumber' },
    { name: 'Invoice Amt', id: 'invoiceAmount' },
    { name: 'Paid Amt', id: 'paidAmount' },
    { name: 'Balance', id: 'balance' },
    { name: 'Paid Date', id: 'paidDate' },
    { name: 'Type', id: 'type' },
    { name: 'PO #', id: 'poNumber' },
  ];
  paymentsHeader = [
    { name: 'Invoice #', id: 'invoiceNumber' },
    { name: 'Invoice Date', id: 'invoiceDate' },
    { name: 'Method', id: 'paymentMethod' },
    { name: 'Ref #', id: 'referenceNumber' },
    { name: 'Order #', id: 'orderId' },
    { name: 'PO #', id: 'poNumber' },
    { name: 'Paid Date', id: 'paidDate' },
    { name: 'Paid Amt', id: 'paidAmount' },
    { name: 'Type', id: 'paymentType' },
  ];
  list: IUITKSelectItemProps[] = [
    { id: '1', label: 'All', value: '1' },
    { id: '2', label: 'Open', value: '2' },
    { id: '3', label: 'None', value: '3' }
  ];
  paymentList: IUITKSelectItemProps[] = [
    { id: '1', label: 'All', value: 'all' },
    { id: '2', label: 'Current Year', value: 'currentYear' },
    { id: '3', label: 'Previous Year', value: 'previousYear' },
    { id: '4', label: 'Custom', value: 'custom' }
  ];
  datePickerConfig: any = {
    minYear: new Date().getUTCFullYear(),
    minMonth: new Date().getUTCMonth() + 1,
    minDay: new Date().getUTCDate() + 1
  };
  paymentFromDate: string = '';
  paymentToDate: string = '';
  swalAlert = new SwalAlert();
  @Input() cmFilter = { id: '1', label: 'All', value: '1' };
  @Input() invoiceFilter = { id: '1', label: 'All', value: '1' };
  paymentFilter = this.paymentList[0];
  selectedTab: number = 0;
  showSendPaymentReceipt = new Dialog<void>();

  ngOnInit(): void {
    this.accountsReceivableService.updateSelectedInvoicesList([]);
    this.accountsReceivableService.updateSelectedOrder(0);

    if (this._activatedRoute.snapshot.params.invoiceId) {
      this.selectedTab = 2;
    }

    this.filter();
    this.getSelectedInvoicesSubscription = this.accountsReceivableService.getSelectedInvoicesEmitter.
      subscribe((invoices: InvoiceDetailsDto[]) => {
        this.selectedInvoices = invoices;
        this.accountsReceivableService.accountIdForTemplate=this.accountInfo.accountId;
        this.orderService.receiptAccountId=this.accountInfo.accountId;
      });

    this.sendCCPdfAccess = this.configService.hasResource('ARInquirySendSelectedToPdfButtonCCMemo');
    this.requiredDatePickerForm.get('fromDatePicker')?.disable();
    this.requiredDatePickerForm.get('toDatePicker')?.disable();
  }

  onSortChange(event: IUITKColumnState): void {
    this.filteredOpenReceivablesDataSource.data = this.filteredOpenReceivablesDataSource.sortData(this.filteredOpenReceivablesDataSource.data, event.direction, event.column);
  }

  onPaginationChange(event: any) {
    const pageEvent: IUITKPaginationEvent = event;
    this.paginationConfig.totalPagesCount = Math.ceil(pageEvent.totalRecords / pageEvent.entriesPerPage);

    switch (pageEvent.event) {

      case PAGINATION_EVENTS.ENTRIES_PER_PAGE:
        if (this.paginationConfig.totalPagesCount < this.paginationConfig.currentPageNumber) {
          this.paginationConfig.currentPageNumber = this.paginationConfig.totalPagesCount;
        }
        break;
      case PAGINATION_EVENTS.PREVIOUS_PAGE:
        this.paginationConfig.currentPageNumber = pageEvent.state.currentPageNumber;
        if (this.paginationConfig.currentPageNumber == 1) {
          this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.slice(0, this.currentPageSize);
        }
        else {
          this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.slice(this.currentPageSize * (this.paginationConfig.currentPageNumber - 1), this.currentPageSize * (this.paginationConfig.currentPageNumber));
        }
        break;
      case PAGINATION_EVENTS.NEXT_PAGE:
        this.paginationConfig.currentPageNumber = pageEvent.state.currentPageNumber;
        if (this.paginationConfig.currentPageNumber == this.paginationConfig.totalPagesCount) {
          this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.slice(this.currentPageSize * (this.paginationConfig.currentPageNumber - 1), pageEvent.totalRecords);
        }
        else {
          this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.slice(this.currentPageSize * (this.paginationConfig.currentPageNumber - 1), this.currentPageSize * (this.paginationConfig.currentPageNumber));
        }
        break;
      case PAGINATION_EVENTS.GO_TO_PAGE:
        if (this.paginationConfig.currentPageNumber == 1) {
          this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.slice(0, this.currentPageSize);
        }
        else if (this.paginationConfig.currentPageNumber == this.paginationConfig.totalPagesCount) {
          this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.slice(this.currentPageSize * (this.paginationConfig.currentPageNumber - 1), pageEvent.totalRecords);
        }
        else {
          this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.slice(this.currentPageSize * (this.paginationConfig.currentPageNumber - 1), this.currentPageSize * (this.paginationConfig.currentPageNumber));
        }
        this.paginationConfig.currentPageNumber = pageEvent.state.currentPageNumber;
        break;
    }
  }

  onPaymentSortChange(event: IUITKColumnState): void {
    //this.filteredPaymentDetailsDataSource.data = this.filteredPaymentDetailsDataSource.sortData(this.filteredPaymentDetailsDataSource.data, event.direction, event.column);
    this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.sortData(this.paymentDetailsDataSource.data, event.direction, event.column).slice(0, this.currentPageSize);
  }

  reload() {
    this.invoiceEdited.emit();
  }

private async handleAccountResults(data: AccountsReceivableResultsDto): Promise<void> {
  this.setBaseAccountData(data);

  if (!this.isValidAccount(data.accountResultDto)) {
    this.isDataFound = false;
    return;
  }

  await this.loadAccountDetails(data.accountResultDto.accountId);
  this.setAccountPeopleDetails();
  this.setTabAndSorting();
}

private setBaseAccountData(data: AccountsReceivableResultsDto): void {
  this.accountInfo = data.accountResultDto;
  this.openReceivablesDataSource.data = data.accountsReceivableResults;

  // Apply default year filter (3 years)
  const cutoffDate = new Date();
  cutoffDate.setFullYear(cutoffDate.getFullYear() - 3);

  this.filteredOpenReceivablesDataSource.data = [...data.accountsReceivableResults];
  this.isDataFound = true;
}

private isValidAccount(account: any): boolean {
  return account != null && account.accountId !== 0;
}

private async loadAccountDetails(accountId: number): Promise<void> {
  this.accountFields =
    await this.apiService.get<BillToDto[]>(
      'Getting account details',
      `${this.configService.apiUrl}/reference/getaccountbilltodetails?accountId=${accountId}&filter=${encodeURIComponent('')}`
    ) ?? [];

  this.calculateAccountBalance();

  this.accountFieldsSingle = this.accountFields.find(a => a.id === accountId)??{} as BillToDto
  ;

  this.setCreditDescription();

  if (!this.accountFieldsSingle) {
    this._modeService.removeFromWaitList("Getting account details");
  }
}

private setCreditDescription(): void {
  const credit = this.accountFieldsSingle?.creditLimit;

  if (credit === 1000) {
    this.creditDescription = '$1,000';
  } else if (credit === 10000) {
    this.creditDescription = '$10,000';
  }
}

private setAccountPeopleDetails(): void {
  const acc = this.accountFieldsSingle;
  const getName = this.configService.getFullNameFromUserCode?.bind(this.configService);
  const getEmail = this.configService.getUserEmailFromUserCode?.bind(this.configService);
  const getSupervisor = this.configService.getUserSupervisorFromUserCode?.bind(this.configService);

  this.accountManager = acc?.accountOwnerCode ? getName(acc.accountOwnerCode) : undefined;
  this.accountManagerEmail = acc?.accountOwnerCode ? getEmail(acc.accountOwnerCode) : undefined;

  this.accountOwnerManagerCode = acc?.accountOwnerCode ? getSupervisor(acc.accountOwnerCode) : undefined;
  this.accountOwnerManager = this.accountOwnerManagerCode ? getName(this.accountOwnerManagerCode) : undefined;
  this.accountOwnerManagerEmail = this.accountOwnerManagerCode ? getEmail(this.accountOwnerManagerCode) : undefined;

  this.softwareExecutive = acc?.softwareExecutiveCode ? getName(acc.softwareExecutiveCode) : undefined;
  this.softwareExecutiveEmail = acc?.softwareExecutiveCode ? getEmail(acc.softwareExecutiveCode) : undefined;

  this.dataRep = acc?.dataFileRepCode ? getName(acc.dataFileRepCode) : undefined;
  this.dataRepEmail = acc?.dataFileRepCode ? getEmail(acc.dataFileRepCode) : undefined;

  this.printRep = acc?.printRepCode ? getName(acc.printRepCode) : undefined;
  this.printRepEmail = acc?.printRepCode ? getEmail(acc.printRepCode) : undefined;

  this.updatePrintManagerDetail();
}

private setTabAndSorting(): void {
  this.tabLabel = this.accountInfo.accountId !== 0
    ? 'A/R: ' + this.accountInfo.accountId.toString()
    : 'A/R Inquiry';

  this._titleService.setTitle(this.tabLabel);

  this.openReceivablesHeader.forEach(header => {
    this.uitkTableSort.setDirection({
      column: header.id,
      direction: UITKSortDirection.UNSORTED
    });
  });

  this.uitkTableSort.setDirection({
    column: 'invoiceDate',
    direction: UITKSortDirection.ASC
  });
}
  async filter(): Promise<void> {
    this.getAccountsReceivableResultsSubscription = this.accountsReceivableService.getAccountsReceivableResultsEmitter
      .subscribe(async (data: AccountsReceivableResultsDto) => {
        this.handleAccountResults(data);
      });
    this.getPaymentsSubscription = this.accountsReceivableService.getPaymentsEmitter
      .subscribe((data: PaymentDetailDto[]) => {
        this.paymentFilter = this.paymentList[0];
        this.paymentFromDate = '';
        this.paymentToDate = '';
        this.requiredDatePickerForm.get('fromDatePicker')?.setValue('');
        this.requiredDatePickerForm.get('toDatePicker')?.setValue('');
        this.requiredDatePickerForm.get('fromDatePicker')?.disable();
        this.requiredDatePickerForm.get('toDatePicker')?.disable();
        this.paymentDetailsDataSource.data = data;
        this.filteredPaymentDetailsDataSource.data = data;
        this.paymentsHeader.forEach(header => {
          this.uitkPaymentTableSort.setDirection({ column: header.id, direction: UITKSortDirection.UNSORTED });
        });
        this.uitkPaymentTableSort.setDirection({ column: 'paidDate', direction: UITKSortDirection.DESC });
        this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.sortData(this.paymentDetailsDataSource.data, UITKSortDirection.DESC , 'paidDate').slice(0, this.currentPageSize);
        this.totalRecords = this.paymentDetailsDataSource.data.length;
        this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.slice(0,this.currentPageSize);
      });

  }
  updatePrintManagerDetail(){
    this.printManagerCode = this.accountFieldsSingle?.printRepCode
            ? this.configService.getUserSupervisorFromUserCode?.(this.accountFieldsSingle.printRepCode)
            : undefined;
          this.printManager = this.printManagerCode
            ? this.configService.getFullNameFromUserCode?.(this.printManagerCode)
            : undefined;
          this.printManagerEmail = this.printManagerCode
            ? this.configService.getUserEmailFromUserCode?.(this.printManagerCode)
            : undefined;
  }
  onInvFilterChange() {
      this.accountsReceivableService.filterInvoices(this.invoiceFilter.id, this.cmFilter.id);
  }

  showSendInvoicePdf(): void {
    this.sendInvoicePdfDialog.show = true;
  }
  async showSelectedTeaplate():Promise<void> {


  const result=  await this.showSelectedTemplate.openAsync();
  if(result==='openTemplateDialog'){
   await this.showTemplateEmail.openAsync();
  }
}

  scrollToTop(e: Event){
    e.stopPropagation();
    let d = document.querySelector('.uitk-c-table__body tr:first-child');
    d?.scrollIntoView({behavior: 'smooth', inline: 'center', block: 'center'});

    setTimeout(() => {
      let a = document.getElementsByClassName('uitk-c-table--responsive')[0];
      a.scrollTop = 0;
    },500);
  }

  calculateAccountBalance(){
    this.accountsReceivableService.getAccountBalanceDetails(this.accountInfo.accountId).then(x => {
      this.accountBalanceDto = x ?? new AccountBalanceDto();
    });
  }
  navigateToSFViewAccount(salesforceId: string): void {
    this.searchInvoiceByCCService.getSalesforceAccountId(this.accountInfo.accountId.toString()).subscribe(data => {
     const salesforceId= data;
    window.open(`${this.configService.salesforceUrl}/apex/ViewAccount?id=${salesforceId}`);
    });
  }

  onYearFilterChange() {
    const selectedYear = this.invoiceYearFilter.value;
    let years: number;

    switch (selectedYear) {
      case '1':
        years = 1;
        break;
      case '2':
        years = 2;
        break;
      case '3':
        years = 3;
        break;
      case '4':
        years = 4;
        break;
      case '5':
        years = 5;
        break;
      default:
        years = 5; // Default to 5 years if no match
    }

    console.log('Selected Year Filter:', selectedYear, 'Years:', years);

    // Filter invoices based on invoice date (client-side filtering)
    const cutoffDate = new Date();
    cutoffDate.setFullYear(cutoffDate.getFullYear() - years);
  }
  onPaymentFilterChange() {
    if(this.paymentFilter.label === "Custom"){
      this.requiredDatePickerForm.get('fromDatePicker')?.enable();
      this.requiredDatePickerForm.get('toDatePicker')?.enable();
    } else {
      this.requiredDatePickerForm.get('fromDatePicker')?.disable();
      this.requiredDatePickerForm.get('toDatePicker')?.disable();
    }
    if(this.paymentFilter.label === "Current Year"){
      this.paymentFromDate = new Date(this.currentYear, 0, 1).toDateString();
      this.paymentToDate = new Date(this.currentYear, 11, 31).toDateString();
      this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.filter(p => new Date(p.paidDate) > new Date(this.currentYear, 0, 1) && new Date(p.paidDate) < new Date(this.currentYear, 11, 31));
    }
    else if(this.paymentFilter.label === "Previous Year"){
      this.paymentFromDate = new Date(this.currentYear - 1, 0, 1).toDateString();
      this.paymentToDate = new Date(this.currentYear - 1, 11, 31).toDateString();
      this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.filter(p => new Date(p.paidDate) > new Date(this.currentYear - 1, 0, 1) && new Date(p.paidDate) < new Date(this.currentYear - 1, 11, 31));
    }
    else{
      this.paymentFromDate = "";
      this.paymentToDate = "";
      this.filteredPaymentDetailsDataSource.data = [...this.paymentDetailsDataSource.data];
    }
    this.totalRecords = this.filteredPaymentDetailsDataSource.data.length;
    if(this.paymentFilter.label !== "Custom" && this.totalRecords === 0){
      this.swalAlert.alert('No payment ledger data available for the selected period.');
    }
  }
  onChangeDate(): boolean {
    this.paymentFromDate = this.requiredDatePickerForm?.controls?.fromDatePicker.value;
    this.paymentToDate = this.requiredDatePickerForm?.controls?.toDatePicker.value;
    if (this.paymentFromDate !== "" && this.paymentToDate !== "") {
      if (this.paymentFromDate > this.paymentToDate) {
        this.swalAlert.alert('End Date should be greater than Start Date.');
        return true;
      }
      this.filteredPaymentDetailsDataSource.data = this.paymentDetailsDataSource.data.filter(p => new Date(p.paidDate) > new Date(this.paymentFromDate) && new Date(p.paidDate) < new Date(this.paymentToDate));
      this.totalRecords = this.filteredPaymentDetailsDataSource.data.length;
    }
    return false;
  }
  async showPaymentLegderEmail(): Promise<void> {
    if(this.paymentFilter.label === "Custom" && (this.paymentFromDate === "" || this.paymentToDate === "")){
      this.swalAlert.alert('Start and End Date must be entered.');
      return;
    }
    if (this.paymentFilter.label === "Custom" && this.onChangeDate()) {
      return;
    }
    const loggedInUserEmail = this.configService.getLoggedInUserEmail();
    const loggedInUserName = this.configService.getLoggedInUserName();
    this.accountsReceivableService.selectedTemplatedValue = "Payment Ledger";
    this.accountsReceivableService.headerForTemplate = "Payment Ledger Email";
    this.accountsReceivableService.EmailSubject = "Account ID " + this.accountInfo.accountId + "-" + "Payment Ledger Attached";
    this.accountsReceivableService.EmailBody = "Attached is the payment ledger copy you requested." + '<br><br>' + "Pay by check or ACH online at : https://billpay.optum.com Login using your 5-digit zip code and the 10-digit Customer Number located at the top of the invoices." + '<br>' + "For product information, online ordering & credit card payments go to: https://optumcoding.com " + '<br><br>' + "Regards," + '<br>' + loggedInUserName + "<br>" + loggedInUserEmail;
    this.accountsReceivableService.paymentPdfEmailDto.dateSeleccionRange = this.paymentFilter.label;
    if (this.paymentFilter.label === "All") {
      this.accountsReceivableService.paymentPdfEmailDto.startDate = null;
      this.accountsReceivableService.paymentPdfEmailDto.endDate = null;
    }
    else{
      this.accountsReceivableService.paymentPdfEmailDto.startDate = new Date(this.paymentFromDate);
      this.accountsReceivableService.paymentPdfEmailDto.endDate = new Date(this.paymentToDate);
    }
    await this.showTemplateEmail.openAsync();
  }
  ngOnDestroy() {
    this.getAccountsReceivableResultsSubscription?.unsubscribe();
    this.getPaymentsSubscription?.unsubscribe();
    this.getSelectedInvoicesSubscription?.unsubscribe();
  }

  async showSendPaymentReceiptPopup(): Promise<void> {
    await this.showSendPaymentReceipt.openAsync();
  }

  get disablePaymentReceipt(): boolean {
    const invoices = this.accountsReceivableService.selectedInvoices;
    if (!invoices || invoices.length === 0) {
      return true
    }
    return invoices.some(invoice => invoice.paidAmount <= 0);
  }

}
